module.exports = __webpack_public_path__ + "static/img/03wr.fc25dae2.webp";